import {
  CancelBookingCancellerEnum,
  InvoiceStatus
} from '@link/supplier/services/const';

export default {
  layouts: {
    sidebar: {
      notifications: '通知',
      contractsList: '與銷售對象的合約狀態',
      activitiesManagement: '商品管理',
      activities: '商品清單',
      allotmentSettings: '設定庫存',
      backendSettings: '後端庫存設定',
      backendCalendar: '行事曆',
      settings: '設定',
      changePassword: '更改密碼',
      suppliers: '供應商管理',
      suppliersDetail: '公司資訊',
      suppliersAccount: '帳戶管理',
      info: '基本資訊',
      detail: '詳細資訊',
      agent: '價格群組設定',
      i18n: '多語言設定',
      planInfo: '方案－{{title}}',
      bookingInfoSettings: '預訂資訊設定',
      price: '單位/價格',
      addPlan: '新增方案',
      editMemo: '編輯備註',
      editLog: '編輯歷史記錄',
      adminSetting: '管理員設定',
      adminPlanInfo: '方案－{{title}} 設定',
      adminActivity: '設定商品',
      allotmentSetting: '營業日・一般庫存設定',
      allotmentSegmentId: '新增開始時間ID',
      allotmentException: '例外開始時間設定',
      allotmentCalendar: '行事曆編輯',
      allotmentOtaGroup: '旅行社庫存群組設定',
      allotmentBackend: '後端設定',
      booking: '預訂',
      unprocessedList: '未處理清單',
      finance: '付款管理',
      bulkOrder: '批次預訂',
      dataExport: '資料匯出'
    }
  },
  views: {
    dataExport: {
      period: '期間',
      dataExport: '資料匯出',
      bookingData: '預訂資料',
      dateMode: '日期模式',
      byBookingDate: '依預訂日',
      byParticipationDate: '依參加日',
      outputMode: '匯出形式',
      byBookings: '依預訂',
      byTravelers: '依旅客',
      status: '狀態',
      download: '下載檔案',
      today: '今天',
      yesterday: '昨天',
      oneWeek: '一週',
      thisMonth: '本月',
      lastMonth: '上月'
    },
    bulkBookingDetail: {
      history: '操作內容',
      action: '操作',
      operator: '操作者',
      date: '日期',
      message: '訊息',
      notifyConfirmed: '匯款審核',
      paymentDate: '匯款日',
      paymentConfirmed: '已核准匯款',
      infoSentToSupplier: '資訊已發送至旅行社'
    },
    dashboard: {
      title: '儀表板'
    },
    activities: {
      templateSource: '商品',
      heading: '商品清單',
      status: '狀態',
      title: '商品名稱',
      inputSupplierTitle: '請輸入商品名稱',
      addActivity: '登錄商品',
      edit: '編輯',
      confirmed: '商品設定完成，可以公開了。',
      name: '商品名稱',
      list: '商品清單',
      addNewActivity: '登錄新商品',
      add: '登錄',
      selectSupplier: '請選擇供應商',
      copyTitle: '複製商品',
      selectSupplierLabel: '供應商選擇',
      copy: '複製',
      copyModalTitle: '複製-{{text}}',
      export: '下載',
      isBulkOrder: '批次預訂'
    },
    backendSettings: {
      newTitle: '設置新的後端庫存',
      management: '庫存登記',
      poolId: '管理 ID',
      supplierId: '供應商名',
      name: '管理用名稱',
      confirm: '確定',
      state: '狀態',
      status: '狀態',
      lastExecution: '最後更新',
      nextExecution: '下次更新',
      jobStatus: {
        success: '成功',
        failed: '失敗'
      }
    },
    activity: {
      mergePlanError: '若商品已存在方案，禁止進行匯入',
      importError: '檔案格式或內容存在問題',
      import: '匯入',
      title: '商品',
      log: {
        logHistory: '商品編輯歷史',
        priceHistory: '價格群組編輯歷史',
        chooseLog: '選擇歷史記錄',
        chooseItemLabel: '方案 {{index}} 編輯歷史',
        html: 'HTML日誌',
        by: '經過'
      },
      memo: {
        title: '編輯備註',
        tips: '編輯備註僅供商品編輯時記錄使用，不會顯示於旅行社或直銷網站上。',
        successUpdated: '備註已儲存'
      },
      tag: {
        title: '編輯標籤',
        tips: '編輯標籤僅供商品編輯時記錄使用，不會顯示於旅行社或直銷網站上。'
      },
      paymentCollector: '收款方',
      productDescription: '商品說明',
      priceSetting: '支付貨幣設定',
      autoPublic: '自動發布設定',
      autoPublicGroup: '目標群組選擇',
      imageSetting: '圖片設定',
      participantNotice: '參加前後注意事項（包含內容等）',
      agentGroupName: '價格群組名稱',
      agentSaved: '已儲存旅行社',
      agentSetting: '設定價格群組',
      addAgentGroup: '新增價格群組',
      agentTips:
        '※價格群組與每家旅行社的價格設定相關聯，因此一家旅行社不能加入多個群組。',
      comment: '備註',
      publishedApplied: '已申請發布',
      rejectApplied: '已退回',
      approved: '已核准',
      published: '已公開',
      publish: '公開',
      publishToNeoOnly: '僅公開至NEO',
      publishToNextOnly: '僅公開至NEXT（現行系統）',
      reject: '退回',
      approve: '發布審核',
      submit: '公開申請',
      save: '儲存',
      preview: '預覽',
      productPreview: '商品預覽',
      voucherPreview: 'Voucher預覽',
      applyForPublish: '申請商品發布',
      productConfirmationMessage:
        '請確認已登錄的商品內容與方案後再進行商品發布。',
      confirmPermission: '沒有權限',
      confirmReject: '退回審核',
      confirmApprovalOfProduct: '審核商品發布',
      productContentConfirmed: '已確認商品內容',
      confirmForPublishingProducts: '商品發布確認',
      productPublishedConfirmed: '已核准商品發布',
      productSaved: '商品已儲存',
      languageSetting: '多語言設定',
      languageSelection: '語言選擇',
      productTitle: '商品名稱（憑證顯示名稱）',
      origin: '出發地',
      destination: '目的地',
      checkinPoints: '集合地點',
      checkoutPoints: '解散地點',
      pickupLocation: '接送地點',
      dropoffLocations: '送達地點',
      cancellationPolicy: '取消政策',
      faqSetting: 'FAQ設定',
      chosenLanguage: '翻譯語言',
      timeZone: '國家・地區（時區）',
      category: '分類',
      useQrCode: 'QR Code 使用設定',
      qrcodeType: 'QR Code 類型',
      qrcodeDisplayLocations: 'QR Code 顯示位置',
      voucherSetting: '憑證設定',
      voucherVersion: '憑證版本',
      appointmentSetting: '預訂設定',
      appointmentNotification: '預訂通知',
      useEticketItems: '電子票券使用項目',
      qrcodeTemplate: 'QR Code 模板',
      qrcodeHeader: 'QR Code 標題區',
      qrcodeFooter: 'QR Code 頁尾',
      qrcodeGenerator: 'QR Code 產生器',
      redemptionUrlTemplate: '兌換URL模板',
      adminSettingSaved: '已儲存管理員設定',
      allotmentSettingSaved: '已儲存方案設定',
      planSelection: '方案選擇',
      planId: '方案ID',
      systemCharge: '系統費用',
      productInfo: '商品資訊',
      supplierId: '供應商ID',
      supplierName: '供應商名',
      name: '商品名稱',
      editMemo: '編輯備註',
      editTag: '編輯標籤',
      publishActivityConfirm: '是否要發布此商品？',
      publishActivitySuccess:
        '※商品公開後，已加入價格設定的旅行社帳號將可查看商品資訊。',
      inPublish: '發布中',
      isActivityPublished: '商品已發布',
      isActivityPublishedFailed: '商品發布失敗',
      contactUs: '造成您的不便，我們深表歉意，請聯絡窗口協助您處理。',
      leaveCurrentPage: '離開此頁面',
      continueEditing: '繼續編輯',
      salesStatus: '商品展示',
      hideFromSearch: '商品列表展示',
      salesStatusNotes: '※若變更商品展示狀態，需重新進行發布，敬請注意。',
      hideFromSearchNotes:
        '※若關閉商品列表展示，將不會顯示於搜尋結果及商品列表畫面，敬請注意。',
      qrCodeTips: '※「依人數發行QR Code」或「剪票使用」設定，請聯絡我司負責人。'
    },
    allotmentSettings: {
      heading: '營業日・一般庫存設定',
      title: '庫存設定',
      new: '登錄庫存',
      poolId: '管理 ID',
      supplierId: '供應商名',
      name: '管理用庫存名稱',
      inputAllotmentName: '請輸入管理用庫存名稱',
      leaveCurrentPage: '離開此頁面',
      continueEditing: '繼續編輯',
      edit: {
        name: '庫存',
        createTitle: '新增庫存',
        copyTitle: '複製庫存'
      },
      form: {
        id: '庫存ID',
        name: '管理用庫存名稱',
        freesale: '無庫存限制',
        copyCalendarEdits: '複製行事曆編輯',
        add: '新增一般庫存'
      },
      exception: {
        name: '特定日期開始時間設定',
        default: '一般庫存',
        allowedDefault: '可使用',
        disallowedDefault: '不可使用',
        defaultApplicable: '（已套用一般庫存設定：{{applicable}}）',
        applicable: '適用',
        notApplicable: '不適用'
      },
      segmentId: {
        name: '開始時間ID',
        addPrompt: '新增開始時間ID',
        refTime: '參考時間',
        startTimeIdRequired: '請輸入開始時間ID',
        startTimeRequired: '請輸入開始時間'
      },
      otaGroup: {
        name: '旅行社庫存群組設定',
        groupName: '旅行社庫存群組名稱',
        addPrompt: '新增旅行社庫存設定',
        addOta: '新增旅行社',
        deleteOta: '刪除旅行社'
      },
      backendBundle: {
        backendOption: '後端',
        bundleOption: '套裝',
        backendId: '後端庫存 ID',
        bundleChildAllotmentPoolId: '關聯子商品庫存ID',
        parentStartTimeId: '開始時間庫存ID',
        refTime: '參考時間',
        childStartTimeId: '子商品開始時間庫存ID',
        addPrompt: '新增關聯子商品ID',
        label: '選擇後端',
        bundleStartTimeSetting: '開始時間ID設定',
        segmentTime: '開始時間ID',
        childSegmentTimeId: '子商品開始時間ID',
        backendAllotment: '設定後端庫存',
        bundleAddPrompt: '新增Bundle庫存設定',
        bundleGroupHeaderText: '關聯子商品ID'
      }
    },
    agentGroup: {
      addAgent: '新增旅行社',
      deleteAgent: '刪除旅行社'
    },
    plan: {
      title: '方案',
      saveConfirm: '已儲存方案',
      name: '方案名',
      planPublish: '方案展示名稱',
      bookingRule: '預訂設定',
      voucherExpiration: '憑證有效期限',
      expirationVisibilitySetting: '隱藏憑證有效期限',
      visibilitySetting: {
        hideFromVoucher: '憑證上不顯示',
        hideFromActivityDetails: '網頁上不顯示（商品內容）',
        hideFromBookingDetails: '網頁上不顯示（預訂詳情）'
      },
      checkinPoint: '集合地點',
      checkoutPoint: '解散地點',
      pickupLocation: '接送地點',
      dropoffLocation: '送達地點',
      unitSetting: '設定單位',
      priceSetting: '設定價格',
      bookingAgentRequiredInfo: '代表者資訊－每筆預訂（必填）',
      bookingAgentRecommendedInfo: '代表者資訊－每筆預訂（選填）',
      bookingOtherRequiredInfo: '其他資訊－每筆預訂（必填）',
      bookingOtherRecommendedInfo: '其他資訊－每筆預訂（選填）',
      participantRequiredInfo: '使用者資訊－每位參加者（必填）',
      participantRecommendedInfo: '使用者資訊－每位參加者（選填）',
      customBookingInfo: '自訂預訂資訊',
      settingUnable: '結束日不能早於開始日設定',
      description: '方案說明',
      imageSetting: '設定圖片',
      availablePeriod: '公開期間',
      reservationRestrict: '預訂數量限制',
      pieces: '張',
      min: '最少',
      max: '最多',
      tilde: '~',
      checklistLabel: '參加前・參加時注意事項（包含內容等）',
      startTime: '開始時間',
      setSchedule: '行程設定',
      editConfirm: '編輯確認',
      leave: '離開此頁面',
      continueEditing: '繼續編輯',
      code: {
        id: '方案ID',
        coupon: '隱藏Bundle子商品憑證',
        backendId: '庫存設定ID',
        backendIdLabel: '請選擇庫存設定',
        goToSetting: '若未設定，請從<0>此處</0>進行設定',
        backend: '後端資訊',
        backendLabel: '請選擇要連動的後端',
        productCode: '商品代碼',
        productCodeLabel: '請填寫商品代碼',
        unit: '單位設定',
        unitType: '單位類型',
        unitRange: '單位範圍',
        unitCode: '單位代碼',
        startTimeTitle: '設定開始時間',
        startTime: '開始時間',
        startTimeCode: '開始時間代碼',
        codeLabel: '請輸入代碼',
        linkToAllotment: '連結至庫存設定'
      },
      planPublishNotes: '※若變更方案顯示狀態，需重新進行商品發布，敬請注意。',
      duplicatePlan: '複製方案',
      ruleDeadlineDayNotes:
        '※若預訂期限輸入「0」，將以【當日】起算並包含當日。',
      voucherExpirationNotes:
        '※若有效期限輸入「1」，將以【當日】起算並包含當日；輸入「0」時將立即失效，請注意。'
    },
    bookingTodos: {
      title: '未處理清單',
      count: '筆',
      within24Hours: '24小時內',
      within5Days: '5天內',
      within7Days: '7天內',
      over7Days: '7日以上',
      purchasedDate: '付款申請日',
      productPlan: '商品/方案',
      bookerName: '預訂者姓名',
      deadline: '截止時間',
      timeRemaining: '距離截止剩餘時間',
      timeRemainingFormat: '{{hours}}小時{{minutes}}分{{seconds}}秒'
    },
    bookingDetail: {
      requestPanelTitle: '待確認訂單處理回覆',
      applicationDate: '申請日期時間',
      deadlineLabel: '截止時間',
      accept: '核准',
      deny: '不可受理',
      rejects: '拒絕',
      denyReasonPlaceholder: '請填寫拒絕理由。',
      actionTitle: '您已{{action}}此預訂請求'
    },
    bookingCancel: {
      form: '取消表單',
      canceller: '取消者',
      reason: '原因',
      comment: '備註',
      cancellationFee: '取消費用',
      time: '目前日期時間',
      money: '金額',
      refundAllSystemFee: '全額退還系統費用',
      discount: 'X',
      percentFormula: '% =',
      pleaseSetCancelFee: '請設定取消費用'
    },
    financeHistory: {
      title: '付款記錄',
      dataAggregation: '數據彙總',
      aggregationUnit: '彙總單位',
      targetPeriod: '期間範圍',
      monthly: '月度',
      weekly: '週次',
      confirmed: '已確定',
      canceledRefund: '取消退款',
      differenceAdjusted: '差額已調整',
      totalAmount: '合計金額',
      cancellationFee: '（含取消費用）',
      serviceFee: '系統費用',
      totalPaymentAmount: '付款金額合計',
      price: '({{currency}})',
      salesPrice: '銷售價格',
      wholesalePrice: '批發價格',
      commission: '手續費',
      transactionSearch: '預訂搜索',
      applicationDate: '申請日',
      participationDate: '參加日',
      transactionStatus: '預訂狀態',
      keyword: '關鍵字',
      activity: '商品',
      plan: '方案',
      supplier: '供應商',
      reservationNumber: '預訂編號',
      currency: '貨幣'
    },
    financeTransactions: {
      title: '結算報表',
      transactionStatus: '結算狀態',
      keyword: 'ID搜尋',
      difference: '差異調整',
      dueDate: '帳單發行日',
      invoiceNumber: '帳單 ID',
      date: '請款期間',
      fromDate: '{{fromDate}}~{{toDate}}',
      currency: '貨幣單位',
      amount: '付款金額合計',
      adjustedAmount: '調整金額',
      finalAmount: '最終合計金額',
      showjust: '顯示',
      change: '付款完成',
      invoice: '帳單明細',
      jaInvoice: '日文請款單',
      jaInvoiceDetails: '明細書(日文)',
      enInvoice: '英文帳單',
      enInvoiceDetails: '明細書(英文)',
      attachment: '附件',
      changeTitle: '是否已完成付款？',
      changeMessage: '交易狀態將變更為「付款完成」'
    }
  },
  common: {
    activityId: '模板ID',
    search: '搜尋',
    leaveCurrentPageConfirm: '{{name}}仍在編輯中',
    successCreatedMsg: '{{name}}新增成功',
    errorCreatedMsg: '{{name}}新增失敗',
    successDeletedMsg: '{{name}}刪除成功',
    errorDeletedMsg: '{{name}}刪除失敗',
    successUpdatedMsg: '{{name}}更新成功',
    errorUpdatedMsg: '{{name}}更新失敗',
    sharedAllotment: '共享庫存',
    colon: '：'
  },
  const: {
    cancelBookingCanceller: {
      [CancelBookingCancellerEnum.Supplier]: '供應商',
      [CancelBookingCancellerEnum.SupplierForTraveler]: '客人'
    },
    templateStatus: {
      DRAFT: '草稿',
      REVIEWING: '發布申請中',
      APPROVED: '已確認發布',
      PUBLISHED: '已公開（僅NEXT）',
      NEO_PUBLISHED: '已公開（僅NEO）',
      BOTH_PUBLISHED: '已公開（NEO・NEXT）'
    },
    jobState: {
      ENABLED: '成功',
      PAUSED: '停止',
      DISABLED: '無效',
      UPDATE_FAILED: '更新失敗',
      ERROR: '錯誤'
    },
    universalType: {
      TRUE: '各方案共用',
      FALSE: '各方案不同'
    },
    voucherType: {
      NONE: '不需要',
      COLLECTIVE: '每筆預訂一個QR Code',
      INDIVIDUAL: '每人一個QR Code'
    },
    qrcodeType: {
      QRCODE: 'QR Code',
      TEXT: '文字',
      URL: 'URL',
      BARCODE_128: '條碼_128',
      BARCODE_93: '條碼_93',
      BARCODE_39: '條碼_39',
      BARCODE_25: '條碼_25'
    },
    qrcodeDisplayLocation: {
      QR_CODE_DISPLAY_LOCATION_VOUCHER: '憑證',
      QR_CODE_DISPLAY_LOCATION_ETICKET_PORTAL_SITE: '電子票券顯示頁面'
    },
    voucherMedium: {
      ELECTRONIC: '無需列印（出示畫面）',
      PAPER: '需要列印'
    },
    voucherVersion: {
      VOUCHER_VERSION_V1: 'V1',
      VOUCHER_VERSION_V2: 'V2'
    },
    formatType: {
      BEFORE_ACTIVITY_FORWARD_FIXED_CLOCK:
        '於使用／參加日前{D}天當地時間{HH:MM}之後取消，將收取預訂總金額的{N}作為取消費用。',
      BEFORE_ACTIVITY_FORWARD_DURATION:
        '於使用／參加時間前{T}小時起取消，將收取預訂總金額的{N}作為取消費用。',
      AFTER_BOOKING_FORWARD_DURATION:
        '於預訂確認後{T}小時起取消，將收取預訂總金額的{N}作為取消費用。',
      AFTER_BOOKING_FORWARD_FIXED_CLOCK:
        '以預訂確認日為第0天，自第{D}天當地時間{HH:MM}起取消，將收取預訂總金額的{N}作為取消費用。',
      BEFORE_ACTIVITY_BACKWARD_FIXED_CLOCK:
        '於使用／參加日前{D}天當地時間{HH:MM}前取消，將收取預訂總金額的{N}作為取消費用。',
      BEFORE_ACTIVITY_BACKWARD_DURATION:
        '於使用／參加時間前{T}小時前取消，將收取預訂總金額的{N}作為取消費用。',
      AFTER_BOOKING_BACKWARD_DURATION:
        '於預訂確認後{T}小時內取消，將收取預訂總金額的{N}作為取消費用。',
      AFTER_BOOKING_BACKWARD_FIXED_CLOCK:
        '以預訂確認日為第0天，至第{D}天當地時間{HH:MM}前取消，將收取預訂總金額的{N}作為取消費用。'
    },
    cancellationFeeType: {
      PERCENTAGE: '百分比',
      ADVANCED_PERCENTAGE: '進階百分比設定',
      FIXED: '固定費用',
      NOT_CANCELLABLE: '不可取消'
    },
    basePrice: {
      GROSS: '銷售價格',
      NET: '批發價格',
      SUPPLIER_NET: '供應商批發價格'
    },
    confirmationType: {
      FREE_SALE: '指定參加日（無庫存限制）',
      FREE_SALE_OPEN_DATE: '不需指定參加日（無庫存限制）',
      INVENTORY: '指定參加日（即時確認）',
      REQUEST: '指定參加日（需待確認）'
    },
    datePeriodUnit: {
      DAY: '以日計算',
      MONTH: '以月計算'
    },
    datePeriod: {
      DAY: '天',
      MONTH: '個月',
      tilde: '~'
    },
    collectingType: {
      PER_PARTICIPANT: '每位參加者',
      PER_BOOKING: '每筆預訂'
    },
    collectingTiming: {
      ON_BOOKING: '預訂時必填',
      BEFORE_ACTIVITY: '參加日前必填',
      OPTIONAL: '選填'
    },
    formType: {
      DATE_ONLY_PAST: '日期（僅限過去）',
      DATE_ONLY_FUTURE: '日期（僅限未來）',
      TIME: '時間',
      YES_NO: '是/否',
      DROPDOWN: '下拉式選單',
      RADIO: '單選按鈕',
      CHECK: '核取方塊',
      TEXT: '文字',
      TEXT_ALPHANUMERIC: '文字（字母數字）',
      TEXT_PHONE: '電話號碼',
      TEXTAREA: '文字區域'
    },
    voucherExpirationType: {
      FROM_PURCHASE_DATE: '自購買日起',
      FROM_ACTIVITY_DATE: '自參加日起',
      FIXED_DATE: '固定日期',
      RELATIVE_FIXED_DATE: '相對日期'
    },
    unit: {
      AGE_ADULT_AND_CHILD: '成人・兒童共用（{n}-{m}）歲',
      AGE_ADULT: '成人（{n}-{m}）歲',
      AGE_YOUTH: '青少年（{n}-{m}）歲',
      AGE_CHILD: '兒童（{n}-{m}）歲',
      AGE_SENIOR: '銀髮族（{n}-{m}）歲',
      AGE_INFANT: '幼兒（{n}-{m}）歲',
      AGE_STUDENT: '學生（{n}-{m}）歲',
      AGE_HIGH_SCHOOL: '高中生（{n}-{m}）歲',
      AGE_INTERMEDIATE_SCHOOL: '國中生（{n}-{m}）歲',
      AGE_ELEMENTALY_SCHOOL: '小學生（{n}-{m}）歲',
      AGE_COLLEGE: '大學生（{n}-{m}）歲',
      AGE_GRADUATE: '研究生（{n}-{m}）歲',
      AGE_DISABLED_ADULT: '身心障礙者－成人（{n}-{m}）歲',
      AGE_DISABLED_YOUTH: '身心障礙者－青少年（{n}-{m}）歲',
      AGE_DISABLED_CHILD: '身心障礙者－兒童（{n}-{m}）歲',
      AGE_SUPPORTER_ADULT: '陪同者（成人）',
      AGE_SUPPORTER_CHILD: '陪同者（兒童）',
      MINUTES_VEHICLES: '{n} 分鐘',
      HOURS_VEHICLES: '{n} 小時',
      DAYS_VEHICLES: '{n} 天',
      WEEKS_VEHICLES: '{n} 週',
      NIGHTS_VEHICLES: '{n} 晚',
      CHARTER_VAR: '每台（{n}-{m}）人',
      GROUP_VAR: '每組（{n}-{m}）人',
      ROOM_VAR: '每房（{n}-{m}）人',
      BOAT_VAR: '每艘（{n}-{m}）人',
      PET: '寵物',
      PET_CAT: '貓',
      PET_DOG: '狗',
      PET_DOG_S: '小型犬',
      PET_DOG_M: '中型犬',
      PET_DOG_L: '大型犬',
      PET_DOG_XL: '超大型犬',
      PET_OTHER: '其他寵物',
      AGE_ADULT_AND_CHILD_2: '普通',
      AGE_CHILD_2: '兒童',
      DRINK_STANDARD_SET: 'THE ROOF SEAT & STANDARD SET',
      DRINK_CHAMPAGNE_SET: 'THE ROOF SEAT & CHAMPAGNE SET',
      QUANTITY: '1個'
    },
    invoiceStatus: {
      [InvoiceStatus.InvoiceStatusPending]: '待入帳',
      [InvoiceStatus.InvoiceStatusConfirmed]: '入帳完成',
      [InvoiceStatus.InvoiceStatusPaid]: '入帳確認中',
      [InvoiceStatus.InvoiceStatusCancelled]: '已取消'
    },
    activityTags: {
      NON_CANCELLABLE: '不可取消',
      FREE_CANCEL_BEFORE_ISSUE_TICKET: '兌換前可免費取消',
      ADVANCE_CANCELLATION_POLICY: '特殊取消政策',
      INSTANT_BOOK: '立即預訂',
      NON_QR_CODE: '人工驗證憑證',
      QR_CODE: 'QR憑證',
      ETICKET: '電子驗票票券（需手機）'
    }
  },
  lang: {
    en: '英文',
    ja: '日文',
    zh: '中文（簡體）',
    zt: '中文（繁體）',
    ko: '韓文'
  },
  component: {
    location: {
      title: '{{label}}名稱',
      address: '地址',
      placeId: '地點 ID',
      latlong: '緯度和經度',
      select: '{{label}}選擇',
      errMsg: '找不到符合條件的結果，請重新確認輸入內容，或從地圖直接選擇。'
    },
    checklist: {
      notice: '注意事項 {{index}}',
      selectNoticePrompt: '請選擇參加前・參加時注意事項',
      uploadPDF: 'PDF上傳',
      uploadImage: '圖片上傳',
      googleMapSetting: 'Google 地圖設定'
    },
    cancel: {
      notCancellable: '預訂完成後恕不接受取消或變更。',
      freeCancellable: '兌換前可免費取消；兌換後恕不接受任何退款。',
      flex: '設定進階取消政策',
      preview: '預覽',
      cancelPreview: '取消政策預覽',
      info: '自訂描述',
      timeSetting: '取消時間設定',
      day: '日期 {D}',
      timeFormat: '時間{HH:MM}',
      time: '時間 {T}',
      feeSetting: '取消費用設定',
      feeSettingPrompt: '請選擇取消費用設定',
      cancelPolicyPrompt: '請選擇取消政策',
      priceReferenceSale: '價格基準：銷售價格',
      priceReference: '價格基準：',
      fromClient: '由旅客支付（%）',
      fromAgent: '由旅行社支付（%）',
      toSupplier: '支付給供應商（%）',
      paymentCancelFee: '取消費用支付',
      fromClientToAgent: '由旅客支付給旅行社',
      fromAgentToLinktivity: '由旅行社支付給LINKTIVITY',
      fromLinktivityToSupplier: '由LINKTIVITY支付給供應商'
    },
    rule: {
      type: '預訂類型',
      possibleInterval: '可預訂最大期間',
      interval: '預訂截止日期',
      daysBefore: '天前',
      timeBefore: '點為止'
    },
    faq: {
      question: '問題',
      answer: '回答',
      faqTitle: '項目 {{index}}'
    },
    voucher: {
      incrementDate: '年度遞增基準日'
    },
    startTime: {
      id: 'ID',
      name: '開始時間',
      title: '標題',
      poolId: '開始時間ID'
    },
    itinerary: {
      title: '標題',
      detailedSchedule: '行程詳細'
    },
    additional: {
      id: '預訂資訊ID',
      title: '預訂資訊標題',
      info: '預訂資訊說明',
      setting: '預訂資訊設定方式',
      deadline: '回覆截止時間',
      answerType: '回覆形式',
      selectItems: '選擇項目',
      selectPrompt: '請選擇'
    },
    price: {
      info: '價錢 {{index}}',
      reservableInterval: '可預訂期間',
      startTime: '開始時間',
      endTime: '結束時間',
      unitType: '單位類型',
      unitPrice: '銷售單價',
      soldPrice: '銷售價格',
      agentPrice: '批發價格',
      comission: '手續費',
      price: '價格',
      accuracy: '精度',
      rate: '匯率',
      comissionRate: '手續費率（顯示用）',
      comissionRateTips: '明細或報表等顯示費率時，將顯示此處設定的費率',
      auto: '費率精度設定',
      applicableSetting: '適用期間設定',
      applicableInterval: '適用期間',
      applicableDates: '適用星期',
      otherApplicableDates: '其他適用日期',
      unitRange: '單位範圍',
      standardPrice: '標準價格',
      numberIncluded: '包含於名額內',
      soloPurchase: '可單獨購買'
    },
    backendForm: {
      cloudSchedulerJob: '同步ID',
      state: '狀態',
      status: '狀態',
      lastExecution: '最後更新',
      nextExecution: '下次更新',
      selectSupplier: '供應商選擇',
      name: '管理名稱',
      backendPoolId: '後端庫存管理ID',
      backend: '後端資訊',
      selectBackendPlaceholder: '請選擇要連動的後端',
      supplierPoolId: '供應商 Pool ID',
      scheduleTimezone: '更新時區',
      schedule: '更新排程',
      scheduleNote: '※填寫方式請參考此處'
    },
    dateSetting: {
      titlePlaceholder: '請輸入庫存管理名稱',
      name: '設定一般庫存',
      interval: '適用期間（星期）',
      exactDates: '特定日期',
      commonAllotment: '庫存設定',
      add: '新增一般庫存樣式',
      common: '共通',
      freesale: '無庫存限制',
      createTitle: '設置庫存樣式',
      modal: {
        interval: '適用期間',
        dates: '適用星期',
        otaAllotments: '旅行社庫存設置'
      }
    },
    editAllotment: {
      type: '類型',
      amountReserved: '預訂數量',
      amountEdited: '庫存數量',
      amountRemains: '剩餘庫存',
      shared: '共享庫存'
    },
    calendar: {
      groupRule: '庫存顯示',
      week: '周',
      month: '月',
      showMore: '詳細',
      amountReserved: '實際預訂數',
      amountLimit: '最大預約數',
      edited: '已於行事曆編輯中設定',
      notice: {
        title: '請謹慎在本頁面直接修改庫存數。',
        orderLabel: '常用設定順序：',
        orderValue: '【營業日・一般庫存設定】→【例外開始時間設定】',
        tempLabel: '臨時調整／緊急關閉：',
        tempValue: '可使用【行事曆編輯】直接修改。',
        priorityLabel: '優先順序規則：',
        priorityValue:
          '【行事曆編輯】（最高）→【例外開始時間設定】（中）→【營業日・一般庫存設定】（基礎）',
        remark:
          '註：於【行事曆編輯】設定庫存後，該時段的一般及例外設定將自動失效，系統僅以【行事曆編輯】的實際數值為準。'
      }
    },
    segmentId: {
      name: '開始時間ID',
      addPrompt: '新增開始時間ID',
      refTime: '參考時間',
      startTimeIdRequired: '請輸入開始時間ID',
      startTimeRequired: '請輸入開始時間'
    }
  }
};
